import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Subcategory from "../Subcategory/Subcategory";
import "./Category.scss";
import ShowAll from "../ShowAll/ShowAll";
import { getCategory, getSubcategory } from "../../../services/products";
import { useCookies } from "react-cookie";
import { getCombos } from "../../../services/meals";
import MenuItem from "../MenuItem/MenuItem";
import Loading from "../Loading/Loading";
import { useNavigate, useParams } from "react-router-dom";

export default function Category({
  active,
  setActive,
  cart,
  setCart,
  showAllId,
  setShowAllId,
  showMessage,
  setShowMessage,
  loading,
  setLoading,
}) {
  const { categoryId, subcategoryId } = useParams("categoryId");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";
  const [cookie] = useCookies(["access_token"]);
  const [subcategories, setSubcategories] = useState([]);
  const [combos, setCombos] = useState([]);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    localStorage.setItem("activeMenu", categoryId);
    getCombos(cookie?.access_token).then((res) => {
      setCombos(res.data);
    });
  }, []);

  useEffect(() => {
    active &&
      getCategory(categoryId, cookie?.access_token).then((res) => {
        if (res?.subcategories?.length > 0 && subcategoryId === undefined) {
          const data = res.subcategories;
          const prioritizedIds = [25, 29];
          data.sort((a, b) => {
            if (
              prioritizedIds.includes(a.id) &&
              !prioritizedIds.includes(b.id)
            ) {
              return -1;
            } else if (
              !prioritizedIds.includes(a.id) &&
              prioritizedIds.includes(b.id)
            ) {
              return 1;
            } else {
              return 0;
            }
          });
          setIsActive(res.isActive);
          setSubcategories(data);
          setShowAllId(null);
          setLoading(false);
        } else {
          if (
            String(window.location.pathname).includes(
              `category/${categoryId}/subcategory/${subcategoryId}`
            )
          ) {
            if (subcategoryId === "combos") {
              getCombos(cookie?.access_token).then((res) =>
                setSubcategories([
                  { id: "combos", name: "Комбо", meals: res.data },
                ])
              );
            } else {
              const subcat = getSubcategory(
                subcategoryId,
                cookie?.access_token
              ).then((res) => setSubcategories([res]));
            }
            setIsActive(res.isActive);
            setShowAllId(subcategoryId);
            setLoading(false);
          } else {
            setIsActive(res.isActive);
            setSubcategories([]);
            setShowAllId(res.id);
            setLoading(false);
          }
        }
      });
  }, [window.location.pathname, active]);

  return (
    <>
      {loading ? (
        <Loading></Loading>
      ) : (
        <div className="category">
          {!showAllId ? (
            <>
              {subcategories && combos?.length > 0 && (
                <Subcategory
                  id={"combos"}
                  products={combos}
                  name={"Комбо"}
                  showAllId={showAllId}
                  setShowAllId={setShowAllId}
                  showMessage={showMessage}
                  setShowMessage={setShowMessage}
                  isActive={isActive}
                  cart={cart}
                  setCart={setCart}
                  isCombo={true}
                  setActive={setActive}
                ></Subcategory>
              )}
              {subcategories &&
                subcategories?.map((subcategory, index) => {
                  if (subcategory?.meals?.length > 0) {
                    const position = index % 2 == 0 ? "left" : "right";
                    return (
                      <Subcategory
                        id={subcategory.id}
                        products={subcategory.meals}
                        name={subcategory.name}
                        image={subcategory?.meals[0]?.images[0]?.url}
                        imagePosition={position}
                        showAllId={showAllId}
                        setShowAllId={setShowAllId}
                        showMessage={showMessage}
                        setShowMessage={setShowMessage}
                        isActive={isActive}
                        cart={cart}
                        setCart={setCart}
                        isCombo={false}
                        setActive={setActive}
                      ></Subcategory>
                    );
                  }
                })}
            </>
          ) : subcategories?.length > 0 ? (
            <ShowAll
              active={active}
              id={showAllId}
              setShowAllId={setShowAllId}
              isSubcategory={true}
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              isActive={isActive}
              setActive={setActive}
            ></ShowAll>
          ) : (
            <ShowAll
              active={active}
              id={showAllId}
              setShowAllId={setShowAllId}
              isSubcategory={false}
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
              isActive={isActive}
              setActive={setActive}
            ></ShowAll>
          )}
        </div>
      )}
    </>
  );
}
